import React from 'react';
import '../DataCollectionGroupPanel.css';
import {  Table } from 'react-bootstrap';
import UnitCellSection from './UnitCellSection.js';

export default class ScreeningSection extends React.Component {         
    getSuccessIndexing(){        
        if (this.props.ScreeningOutput_indexingSuccess){
            return <div className='summary_datacollection_success'> </div>
        }
        return <div className='summary_datacollection_failed'></div>
    }

    getUnitCellSection(){
        if (this.props.ScreeningOutput_strategySuccess){
            return <UnitCellSection
                            cell_a = {this.props.ScreeningOutputLattice_unitCell_a}
                            cell_b = {this.props.ScreeningOutputLattice_unitCell_b}
                            cell_c = {this.props.ScreeningOutputLattice_unitCell_c}
                            cell_alpha = {this.props.ScreeningOutputLattice_unitCell_alpha}
                            cell_beta = {this.props.ScreeningOutputLattice_unitCell_beta}
                            cell_gamma = {this.props.ScreeningOutputLattice_unitCell_gamma}                    
                    ></UnitCellSection> ;
        }
    }

    getRankingResolution(){
        if (this.props.ScreeningOutput_strategySuccess){
            return <tr>
                            <td colSpan='2'>Rank. Res.</td>
                            <td colSpan='2' ><span style={{fontWeight:'bold'}}>{this.props.ScreeningOutput_rankingResolution} &#8491;</span></td>                                
                        </tr>;
        }
    }
    getStrategyOsc(){
        if (this.props.ScreeningOutput_strategySuccess){
            return <tr>                              
                            <td colSpan='2'>Osc. start (total)</td>
                            <td colSpan='2'><span style={{fontWeight:'bold'}}>{this.props.ScreeningStrategySubWedge_axisStart} &deg; ({this.props.ScreeningOutput_totalRotationRange} &deg;)</span></td>                                                               
                        </tr>;
        }
    }

    render(){               
        return  <div>
                    <Table responsive condensed  className="parameterKey" >
                        <tbody>
                            <Indexed ScreeningOutput_indexingSuccess={this.props.ScreeningOutput_indexingSuccess} ScreeningOutput_mosaicity={this.props.ScreeningOutput_mosaicity}></Indexed>                                                       
                     
                        <StrategyHeader 
                            ScreeningOutput_strategySuccess={this.props.ScreeningOutput_strategySuccess}
                            ScreeningOutputLattice_spaceGroup={this.props.ScreeningOutputLattice_spaceGroup}                            
                        >
                        </StrategyHeader>
                        {this.getRankingResolution()}
                        {this.getStrategyOsc()}
                        <StrategyImages 
                            ScreeningOutput_strategySuccess={this.props.ScreeningOutput_strategySuccess}                 
                            ScreeningStrategySubWedge_numberOfImages={this.props.ScreeningStrategySubWedge_numberOfImages}
                            ScreeningStrategySubWedge_oscillationRange={this.props.ScreeningStrategySubWedge_oscillationRange}                          
                        >
                        </StrategyImages>
                        <StrategyOscRange
                            ScreeningOutput_strategySuccess={this.props.ScreeningOutput_strategySuccess}                 
                            ScreeningStrategySubWedge_numberOfImages={this.props.ScreeningStrategySubWedge_numberOfImages}
                            ScreeningStrategySubWedge_oscillationRange={this.props.ScreeningStrategySubWedge_oscillationRange}                          
                        >
                        </StrategyOscRange>

                         <StrategyTransmission 
                            ScreeningOutput_strategySuccess={this.props.ScreeningOutput_strategySuccess}    
                            ScreeningStrategySubWedge_transmission={this.props.ScreeningStrategySubWedge_transmission}                 
                            ScreeningStrategySubWedge_exposureTime={this.props.ScreeningStrategySubWedge_exposureTime}                            
                        >
                        </StrategyTransmission>  
                        <StrategyExpTime 
                            ScreeningOutput_strategySuccess={this.props.ScreeningOutput_strategySuccess}    
                            ScreeningStrategySubWedge_transmission={this.props.ScreeningStrategySubWedge_transmission}                 
                            ScreeningStrategySubWedge_exposureTime={this.props.ScreeningStrategySubWedge_exposureTime}                            
                        >
                        </StrategyExpTime>  
                                              
                       </tbody>                      
                    </Table>
                    {this.getUnitCellSection()}
                       
            </div>;
    }
}


class Indexed extends React.Component { 
    getSuccessIndexing(){        
        if (this.props.ScreeningOutput_indexingSuccess){
            return <div className='summary_datacollection_success'> </div>
        }
        return <div className='summary_datacollection_failed'></div>
    }

    getMosaicity(){        
        if (this.props.ScreeningOutput_indexingSuccess){
            return <div className='summary_datacollection_success'> </div>
        }
        return <div className='summary_datacollection_failed'></div>
    }

    render(){       
            return <tr>
                    <td>
                        <span>Indexed</span>
                    </td>
                    <td>
                        {this.getSuccessIndexing()}
                    </td>
                        <td>Mosaicity</td>
                        <td className='parameterValue'>{this.props.ScreeningOutput_mosaicity}</td>
                </tr>;
        
       
    }
}

class StrategyHeader extends React.Component { 
     render(){   
        if (this.props.ScreeningOutput_strategySuccess){    
            return  <tr>
                                <td>
                                    <span>Strategy</span>
                                </td>
                                 <td>
                                    <div className='summary_datacollection_success'></div>
                                </td>
                                <td>Space Group</td>
                                <td className='parameterValue'>{this.props.ScreeningOutputLattice_spaceGroup}</td>                                                                
                            </tr>;
        }
        return <tr>
                <td>
                    <span>Strategy</span>
                </td>
                    <td>
                    <div className='summary_datacollection_failed'></div>
                </td>                                                                                                                       
            </tr>; 

    }
}



class StrategyImages extends React.Component { 
     render(){   
        if (this.props.ScreeningOutput_strategySuccess){    
            return  <tr>
                                <td colSpan='2'>Images</td>
                                <td colSpan='2' className='parameterValue'>{this.props.ScreeningStrategySubWedge_numberOfImages}</td>                              
                    </tr>;
        }
        return null; 
    }
}
class StrategyOscRange extends React.Component { 
     render(){   
        if (this.props.ScreeningOutput_strategySuccess){    
            return  <tr>                              
                                <td colSpan='2'>Osc. range</td>
                                <td colSpan='2' className='parameterValue'>{this.props.ScreeningStrategySubWedge_oscillationRange} &deg;</td>
                    </tr>;
        }
        return null; 
    }
}


class StrategyTransmission extends React.Component { 
     render(){   
        if (this.props.ScreeningOutput_strategySuccess){    
            return  <tr>                             
                                <td colSpan='2'>Transmission</td>
                                <td colSpan='2' className='parameterValue'>{this.props.ScreeningStrategySubWedge_transmission} s</td>
                            </tr>;
        }
        return null; 
    }
}

class StrategyExpTime extends React.Component { 
     render(){   
        if (this.props.ScreeningOutput_strategySuccess){    
            return  <tr>                            
                                <td colSpan='2'>Exp. Time</td>
                                <td colSpan='2' className='parameterValue'>{this.props.ScreeningStrategySubWedge_exposureTime} s</td>
                            </tr>;
        }
        return null; 
    }
}







// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/ScreeningSection.js